import { createHashHistory } from 'history'; // history路由

const history = createHashHistory();
export default history;
